module.exports = __webpack_public_path__ + "static/media/blog-3.d7187400.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog-3.jpg
// module id = 844
// module chunks = 0